import  {
  DrawerContentComponentProps,
  DrawerContentScrollView,
  DrawerItemList,
} from "@react-navigation/drawer";
import { useAppSelector } from "./redux/store";
import { useTranslation } from "react-i18next";
import { Divider, Icon, Text, useTheme } from "react-native-paper";
import { StyleSheet, View } from "react-native";
import { VersionDisplay } from "./components/VersionDisplay";
import React from "react";
import UserAvatar from "./components/UserAvatar";

export function CustomDrawerContent(props: DrawerContentComponentProps) {
  const user = useAppSelector((state) => state.auth.user);
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <DrawerContentScrollView {...props}>
      <View style={styles.userContainer}>
        <View style={styles.avatarContainer}>
          <UserAvatar
            size={50}
            avatarUrl={user.avatarUrl}
            fullName={user.fullName}
            email={user.email}
          />
        </View>

        <View style={styles.userInfo}>
          <Text variant="titleMedium" style={styles.userName}>
            {user.fullName}
          </Text>
          <Text variant="bodySmall" style={styles.userRole}>
            {t(user.role)}
          </Text>
        </View>

        <Divider style={styles.divider} />

        <View style={styles.detailsContainer}>
          <View style={styles.detailRow}>
            <Icon source="email" size={20} color={theme.colors.primary} />
            <Text variant="bodyMedium" style={styles.detailText}>
              {user.email}
            </Text>
          </View>

          <View style={styles.detailRow}>
            <Icon
              source="office-building"
              size={20}
              color={theme.colors.primary}
            />
            <Text variant="bodyMedium" style={styles.detailText}>
              {user.company?.name}
            </Text>
          </View>
        </View>
      </View>
      <DrawerItemList {...props} />
      <VersionDisplay />
    </DrawerContentScrollView>
  );
}

const styles = StyleSheet.create({
  userContainer: {
    padding: 16,
  },
  avatarContainer: {
    alignItems: "center",
    marginBottom: 12,
  },
  userInfo: {
    alignItems: "center",
  },
  userName: {
    fontWeight: "bold",
    marginBottom: 4,
  },
  userRole: {
    color: "gray",
  },
  divider: {
    marginVertical: 16,
  },
  detailsContainer: {
    gap: 12,
  },
  detailRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  detailText: {
    flex: 1,
  },
});
